import { createFileRoute } from '@tanstack/react-router';
import { DepartmentsPage } from '@/features/lookups/departments-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/hr/departments')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/hr/departments');
  },
  component: DepartmentsPage,
});
